import { useEffect, useState } from "react";

import { useConfig } from "@jti/app-context/useConfig";
import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";

import { X_SELLING_POPUP_GTM_CTA_LOCATION } from "./const/tracking";

import { XSellingDialog, type XSellingDialogProductCardProps, type XSellingDialogProps } from "./components";
import { XSellingDialogEvents } from "./events";

export type XSellingDialogModelData = {
  title: string;
  subtitle?: string;
  confirmButtonText: string;
  cancelButtonText: string;
  confirmRedirectUrl: string;
  products: XSellingDialogProductCardProps[];
  showQuickAddToCartButton?: boolean;
};

const xSellingDialogModelDataToXSellingDialogProps = (
  modelData: XSellingDialogModelData
): Omit<XSellingDialogProps, "onClose" | "onConfirm" | "isOpened"> => ({
  title: modelData.title,
  subtitle: modelData.subtitle,
  confirmButtonText: modelData.confirmButtonText,
  cancelButtonText: modelData.cancelButtonText,
  products: modelData.products,
  showQuickAddToCartButton: modelData.showQuickAddToCartButton,
});

export const XSellingDialogWrapper = (props: XSellingDialogModelData) => {
  const { CART_CHECKOUT_PAGE_URL } = useConfig();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const abortController = new AbortController();

    window.addEventListener(XSellingDialogEvents.open, () => setIsOpen(true), { signal: abortController.signal });

    return () => abortController.abort();
  }, []);

  const handleConfirmClick = async () => {
    await dispatchTrackingEvent(TrackingEvents.TrackingCtaClick, {
      cta_name: props.confirmButtonText,
      cta_location: X_SELLING_POPUP_GTM_CTA_LOCATION,
    });
    window.location.assign(props.confirmRedirectUrl);
  };

  const handleCloseClick = async () => {
    await dispatchTrackingEvent(TrackingEvents.TrackingCtaClick, {
      cta_name: props.cancelButtonText,
      cta_location: X_SELLING_POPUP_GTM_CTA_LOCATION,
    });
    window.location.assign(CART_CHECKOUT_PAGE_URL);
  };

  return (
    isOpen && (
      <XSellingDialog
        isOpened={isOpen}
        onClose={handleCloseClick}
        onConfirm={handleConfirmClick}
        {...xSellingDialogModelDataToXSellingDialogProps(props)}
      />
    )
  );
};
